import {
    Directive,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

import cloneDeep from 'lodash-es/cloneDeep';
import isEqual from 'lodash-es/isEqual';
import { Subscription } from 'rxjs';

/*
Due to the fact that IE marks controls as dirty when placeholders are present.
Until there's an official fix in @angular/forms, we'll override the FG directive.
*/
@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[formGroup]',
})
class UiFormGroupDirective
    extends FormGroupDirective
    implements OnInit, OnDestroy {
    /**
     * Cache the form values when value changes occur.
     * Values get cached only if the new value is set while the input is pristine (initial load).
     * Forms will be by default pristine if the old values are present.
     */
    private _cache: any = {};
    private _valueSub!: Subscription;

    ngOnInit() {
        {
            const keys = Object.keys(this.form.controls);
            for (const key of keys) {
                this._updateCacheValueFor(key, this.form.controls[key].value);
            }
        }
        if (!this._valueSub || this._valueSub.closed) {
            this._valueSub = this.form.valueChanges.subscribe(change => {
                const keys = Object.keys(this.form.controls);
                // clear cache entry for removed controls
                const staleKeys = Object.keys(this._cache).filter(k => !keys.includes(k));
                for (const key of staleKeys) {
                    delete this._cache[key];
                }
                // evaluate and set cache for a newly initialized form group
                for (const key of keys) {
                    this._updateCacheValueFor(key, change[key]);
                }
            });
        }

        // overload reset method to include cache clearing
        const reset = this.form.reset.bind(this.form);

        this.form.reset = (value?: any, options?: any) => {
            this._cache = {};
            reset(value, options || {
                onlySelf: true,
                emitEvent: true,
            });
        };
    }

    ngOnDestroy() {
        if (this._valueSub) { this._valueSub.unsubscribe(); }
    }

    private _updateCacheValueFor(key: string, value: string | number | boolean) {
        value = !!value ? cloneDeep(value) : value;
        const control = this.form.get([key])!;

        if (value == null) {
            if (
                !this._cache.hasOwnProperty(key) ||
                this._cache === ''
            ) {
                this._cache[key] = '';

                control.markAsPristine();
            }
            return;
        }
        if (
            control.pristine &&
            !isEqual(this._cache[key], value)
        ) {
            this._cache[key] = value;
            control.markAsPristine();
        } else if (isEqual(this._cache[key], value)) {
            control.markAsPristine();
        }
    }
}

export { UiFormGroupDirective as FormGroupDirective };
